import React, { useEffect } from "react";
import { Box, Container, Link, Paper, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function PolicyLayout({ title, children }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | ProspectEngage`;
    window.scrollTo(0, 0);
    return () => { document.title = previousTitle; };
  }, [title]);

  return (
    <Box sx={{ minHeight: "100vh", py: { xs: 3, sm: 6 }, background: "linear-gradient(150deg, #e8f5d4 0%, #f8fafc 60%)" }}>
      <Container maxWidth="md">
        <Box component="header" sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 3 }}>
          <Typography component="div" sx={{ fontSize: 28, fontWeight: 800, color: "#00336C" }}>
            Prospect<Box component="span" sx={{ color: "#648315" }}>Engage</Box>
          </Typography>
          <Link component={RouterLink} to="/login" sx={{ color: "#00336C" }}>Back to login</Link>
        </Box>
        <Paper component="main" elevation={0} sx={{ p: { xs: 3, sm: 6 }, borderRadius: 4, borderTop: "4px solid #648315", boxShadow: "0 4px 24px rgba(0,51,108,0.09)" }}>
          <Typography component="h1" variant="h4" sx={{ color: "#00336C", fontWeight: 800, mb: 2 }}>{title}</Typography>
          {children}
        </Paper>
        <Box component="nav" aria-label="Legal and privacy" sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 3, mt: 3 }}>
          <Link component={RouterLink} to="/legal" aria-current={title === "Legal" ? "page" : undefined} sx={{ color: "#00336C" }}>Legal</Link>
          <Link component={RouterLink} to="/privacy" aria-current={title === "Privacy Policy" ? "page" : undefined} sx={{ color: "#00336C" }}>Privacy Policy</Link>
        </Box>
      </Container>
    </Box>
  );
}

export function PolicySection({ title, children }) {
  return (
    <Box component="section" sx={{ mt: 3 }}>
      <Typography component="h2" variant="h6" sx={{ color: "#00336C", fontWeight: 700, mb: 1 }}>{title}</Typography>
      <Typography sx={{ color: "#475569", lineHeight: 1.8 }}>{children}</Typography>
    </Box>
  );
}
